import useGlobalState from './useGlobalState.hooks';
import { useStatsigLayer } from './useStatsigLayer.hook';

export const useHeaderCtaCopy = (contentfulButtonText: string) => {
  const { isLoggedIn } = useGlobalState();
  const { getEnglishOnlyText: getAnonymousEnglishOnlyText, isReady: isAnonymousReady } =
    useStatsigLayer('track_my_parcel_copy_layer');
  const { getEnglishOnlyText: getSignedInEnglishOnlyText, isReady: isSignedInReady } = useStatsigLayer(
    'track_my_parcel_signed_in_layer',
  );

  const fallback = { headerCtaCopy: contentfulButtonText };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const getEnglishOnlyText = isLoggedIn ? getSignedInEnglishOnlyText : getAnonymousEnglishOnlyText;
  return {
    headerCtaCopy: getEnglishOnlyText('header_cta_copy', contentfulButtonText),
  };
};
